export default __webpack_public_path__ + "static/media/long-blue-pattern.e5ddd331.svg";